import React from "react";

const StorageUnitRoomDetailsPage = () => {
  return (
    <div>
      <h1 className="text-uppercase">room details</h1>
    </div>
  );
};

export default StorageUnitRoomDetailsPage;
